import { makeAutoObservable } from "mobx"
import {  getStockDetailData } from "../../../modules/quote/web"
import { getPageType, PageType } from "../../shared/pagetype"
import { ChartType } from "../../shared/utils"

class Store {
  constructor() {
    if (getPageType() == PageType.债券) {
      makeAutoObservable(this)
      this.init()
    }
  }

  StockDetail: any = undefined

  chartType = ChartType.分时

  chart_mouse_move_data: any = null
  

  async init() {
    this.getData()

    setInterval(() => {
      this.getData()
    }, 30 * 1000)
  }

  async getData() {
    let data = await getStockDetailData(window.quotedata.quotecode, "f43,f44,f45,f46,f47,f48,f49,f50,f51,f52,f57,f59,f60,f71,f107,f113,f114,f115,f117,f152,f154,f168,f169,f170,f171,f177,f262,f264,f265,f266,f267,f268,f292,f301,f427,f428,f531,f700,f701,f702,f703,f704,f705,f706,f721,f724,f725,f727,f728,f731,f734")
    this.setStockDetail(data)
  }

  setStockDetail(StockDetail: any) { 
    this.StockDetail = StockDetail
  }

  setChartType(chartType: ChartType) {
    this.chartType = chartType
  }

  setChartMouseMoveData(chart_mouse_move_data: any) {
    this.chart_mouse_move_data = chart_mouse_move_data
  }
}

export const store = new Store()
